const STORAGE_KEY = 'melio_agent_id';

const generateUUID = (): string => {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

let cachedAgentId: string | undefined;

export const getAgentId = (): string => {
  if (cachedAgentId) {
    return cachedAgentId;
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      cachedAgentId = stored;
      return stored;
    }
  } catch {
    // localStorage may be unavailable (e.g. private browsing)
  }

  const agentId = generateUUID();
  cachedAgentId = agentId;

  try {
    localStorage.setItem(STORAGE_KEY, agentId);
  } catch {
    // localStorage may be unavailable (e.g. private browsing)
  }

  return agentId;
};
